export const HEALTH_CONDITIONS = [
    "Diabetes",
    "PCOS",
    "Thyroid",
    "Hypertension",
    "Cholesterol",
    "Anemia",
    "None",
];

export const BMI_MIN = 18.5;
export const BMI_MAX = 27.5;

export const PAYMENT_TYPE = "subscription";
export const SUBSCRIPTION_AMOUNT_PAISE = 39900;
export const SUBSCRIPTION_DISPLAY_PRICE = `₹${SUBSCRIPTION_AMOUNT_PAISE / 100}`;
